export const ENVS = {
  DEV: "dev",
  STAGE: "stage",
  PP: "pp",
  BETA: "beta",
  PROD: "prod",
};
